import SingleEntryAttributeContainer from './SingleEntryAttribute'

const nonListedFields = ['last_name', 'first_names']

// Get list of attributes to show
export const getFields = (
  fieldMapper: { [index: string]: { [index: string]: string } },
  registryName: string,
  registry: any,
  compressed = false
): any => {
  const keys: string[] = Object.keys(fieldMapper)
  if (keys.includes(registryName)) {
    return Object.keys(fieldMapper[registryName]).map((fieldName, key) => {
      const name = fieldMapper[registryName][fieldName]
      const value = registry[fieldName]
      if (nonListedFields.includes(fieldName)) return false
      return (
        <SingleEntryAttributeContainer
          key={name + value + key.toString()}
          name={name}
          value={value}
          hidden={false}
          compressed={compressed}
        />
      )
    })
  }
  return []
}